<app-header [forceLightBackground]="true"></app-header>
<div class="admin-my-submissions">
  <div class="admin-my-submissions--layout">
    <app-admin-sidebar class="admin-my-submissions--sidebar"></app-admin-sidebar>
    <div class="admin-my-submissions--content">
      <app-page-header></app-page-header>
      <div class="my-submissions--container">
        <app-my-submissions [showPanelHeader]="false"></app-my-submissions>
      </div>
    </div>
  </div>
</div>
